import { Link, graphql, useStaticQuery } from "gatsby";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import SvgLocation from "../../../../assets/icons/SvgLocation";
import SvgRightCaret from "../../../../assets/icons/SvgRightCaret";
import { LOGGEDIN } from "../../../../constants/auth";
import { userLoggedOut } from "../../../../slices/auth";
import NavDrawer from "../../../common/NavDrawer";
import CountryDrawer from "./CountryDrawer";
import MenuDrawer from "./MenuDrawer";
import MenuItem from "./MenuItem";

const ACTIVE_LOCALE = process.env.GATSBY_LOCALE_CURRENCY;
const country = process.env.GATSBY_LOCALE_COUNTRY;
const ACTIVE_CLUB = process.env.GATSBY_CLUB_ACTIVE;

export default function MobileMenu({ isOpen, setOpen, data }) {
  const { allContentfulDomain } = useStaticQuery(graphql`
    {
      allContentfulDomain {
        nodes {
          title
          isoCode
          currencyCode
          url
        }
      }
    }
  `);

  const locations = allContentfulDomain.nodes;
  const { authState } = useSelector((state) => state.auth);
  const [selectedLocation, setSelectedLocation] = useState(
    locations.find((node) => node.currencyCode === ACTIVE_LOCALE)
  );
  const isPartners = ACTIVE_CLUB === "club_pt";
  const dispatch = useDispatch();

  const [drawer, setDrawer] = useState("home");

  const navOtherItems = [
    {
      title: authState === LOGGEDIN ? "My Account" : "Log in",
      drawer: null,
      link: authState === LOGGEDIN ? "/pages/bushbuck-club" : "/account/login",
    },
    {
      title: authState === LOGGEDIN ? "" : "Join Club",
      drawer: null,
      link: authState === LOGGEDIN ? "" : "/pages/bushbuck-club",
    },
    { title: "Need help?", drawer: "help" },
  ];
  React.useEffect(() => {
    if (!isOpen) {
      setDrawer("home");
    }
    if (isOpen) document.body.style.overflow = "hidden";
    else document.body.style.overflow = "auto";
  });

  function handleLogout() {
    dispatch(userLoggedOut());
    setOpen(false);
  }

  return (
    <NavDrawer
      isOpen={isOpen}
      cls="max-w-[400px] overflow-y-auto text-white"
      placement="left"
    >
      <div className="flex flex-col w-full relative">
        <React.Fragment>
          <div className="flex flex-col py-14 bg-center relative">
            <MenuItem
              data={data.clothing}
              setDrawer={setDrawer}
              drawerName="clothing"
            />
            <MenuItem
              data={data.camping}
              setDrawer={setDrawer}
              drawerName="camping"
            />
            <MenuItem
              data={data.rooftopTents}
              setDrawer={setDrawer}
              drawerName="rooftopTents"
            />
            <MenuItem
              data={data.accessories}
              setDrawer={setDrawer}
              drawerName="accessories"
            />
            {country !== "AU" && (
              <MenuItem
                data={data.hunting}
                setDrawer={setDrawer}
                drawerName="hunting"
              />
            )}
            {!data.hideBundles && (
                <Link
                    className="cursor-pointer font-bold text-xl py-[10px] pl-8 pr-[52px] flex justify-between items-center tracking-wide"
                    to="/collections/shop-bundles"
                >
                  Bundles
                </Link>
            )}
            {!data.hideSale && (
                <div className="px-8 py-[10px]">
                  <Link
                      className="primary_btn w-full bg-white text-primary-500 font-bold text-xl"
                      to={data.sale.slug}
                  >
                    {data.sale.title}
                  </Link>
                </div>
            )}

            <div className="invisible my-[25px]"/>
            {navOtherItems.map((item) =>
                item.drawer
                ? item.title && (
                    <p
                      key={item.title}
                      to={item.link || ""}
                      className="cursor-pointer text-white no-underline font-bold py-[10px] pl-8 pr-[52px] flex justify-between items-center border-t border-solid border-t-primary-400 text-sm mx-[10px]"
                      role="button"
                      onClick={() => setDrawer(item.drawer)}
                    >
                      {item.title}
                      {item.drawer && (
                        <SvgRightCaret
                          style={{
                            position: "absolute",
                            right: "40px",
                            width: "12px",
                            height: "12px",
                            transform: "rotate(270deg)",
                          }}
                        />
                      )}
                    </p>
                  )
                : item.title && (
                    <Link
                      key={item.title}
                      to={item.link || ""}
                      className="cursor-pointer text-white no-underline font-bold py-[10px] pl-8 pr-[52px] flex justify-between items-center border-t border-solid border-t-primary-400 text-sm mx-[10px]"
                      role="button"
                      onClick={() => setDrawer(item.drawer)}
                    >
                      {item.title}
                      {item.drawer && (
                        <SvgRightCaret
                          style={{
                            position: "absolute",
                            right: "40px",
                            width: "12px",
                            height: "12px",
                            transform: "rotate(270deg)",
                          }}
                        />
                      )}
                    </Link>
                  )
            )}
            {authState === LOGGEDIN && (
              <button
                className="cursor-pointer text-white no-underline font-bold py-[10px] pl-8 pr-[52px] flex justify-between items-center border-t border-solid
                border-t-primary-400 text-sm mx-[10px]"
                role="button"
                onClick={handleLogout}
              >
                Logout
              </button>
            )}
            {!isPartners && (
              <p
                className="cursor-pointer font-bold py-[10px] pl-8 pr-[52px] flex justify-between items-center border-t border-solid border-t-primary-400
                text-sm mx-[10px]"
                role="button"
                onClick={() => setDrawer("country")}
              >
                <SvgLocation
                  style={{
                    position: "absolute",
                    left: "20px",
                  }}
                />
                {selectedLocation.title} ({selectedLocation.currencyCode})
              </p>
            )}
          </div>
        </React.Fragment>
        <MenuDrawer
          title={data.clothing.title}
          data={data.clothing.collections}
          isOpen={drawer === "clothing"}
          setMainDrawer={setDrawer}
        />
        <MenuDrawer
          isOpen={drawer === "camping"}
          setMainDrawer={setDrawer}
          title={data.camping.title}
          data={data.camping.collections}
        />
        <MenuDrawer
          isOpen={drawer === "rooftopTents"}
          setMainDrawer={setDrawer}
          title={data.rooftopTents.title}
          data={data.rooftopTents.collections}
        />
        <MenuDrawer
          isOpen={drawer === "accessories"}
          setMainDrawer={setDrawer}
          title={data.accessories.title}
          data={data.accessories.collections}
        />
        <MenuDrawer
          isOpen={drawer === "hunting"}
          setMainDrawer={setDrawer}
          title={data.hunting.title}
          data={data.hunting.collections}
        />
        <MenuDrawer
          isOpen={drawer === "help"}
          setMainDrawer={setDrawer}
          title="Need help?"
          data={data.helpLinks}
        />

        <CountryDrawer
          locations={locations}
          setSelectedLocation={setSelectedLocation}
          isOpen={drawer === "country"}
          setMainDrawer={setDrawer}
        />
      </div>
    </NavDrawer>
  );
}
